import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="password-generator"
export default class extends Controller {
  static targets = ["passwordField"]

  generate() {
    // Генерируем случайный пароль из 10 цифр
    const password = Math.floor(Math.random() * 10000000000).toString().padStart(10, '0')
    this.passwordFieldTarget.value = password
  }

  copy() {
    const passwordField = this.passwordFieldTarget
    if (passwordField.value.trim() === '') {
      alert('Сначала сгенерируйте пароль')
      return
    }

    // Копируем пароль в буфер обмена
    navigator.clipboard.writeText(passwordField.value).then(() => {
      // Показываем уведомление
      this.showCopyNotification()
    }).catch(err => {
      console.error('Ошибка при копировании: ', err)
      // Fallback для старых браузеров
      passwordField.select()
      document.execCommand('copy')
      this.showCopyNotification()
    })
  }

  showCopyNotification() {
    // Создаем временное уведомление
    const notification = document.createElement('div')
    notification.className = 'alert alert-success position-fixed'
    notification.style.cssText = 'top: 20px; right: 20px; z-index: 9999; opacity: 0; transition: opacity 0.3s;'
    notification.textContent = 'Пароль скопирован!'
    
    document.body.appendChild(notification)
    
    // Анимация появления
    setTimeout(() => {
      notification.style.opacity = '1'
    }, 10)
    
    // Удаление через 2 секунды
    setTimeout(() => {
      notification.style.opacity = '0'
      setTimeout(() => {
        if (notification.parentNode) {
          notification.parentNode.removeChild(notification)
        }
      }, 300)
    }, 2000)
  }
}
